import { ObraHeaderInfo } from "../../domain/models/obra_header_info";
import { useMemo } from "react";

import RefreshButton from "../../../../common/components/refresh_button";
import DynamicIcon from "../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../common/components/primary_button";

/**
 * ObrasTopHeader
 */

type Props = {
  title: string;
  selectedObra: ObraHeaderInfo | null;
  additionalHeader?: React.ReactNode;
  onReload: () => void;
  onNewItem?: () => void | null;
};

export const ObrasTopHeader = ({
  title,
  selectedObra,
  additionalHeader,
  onReload,
  onNewItem,
}: Props) => {
  const headerObraInformation = useMemo(() => {
    return (
      selectedObra && (
        <div className="w-full flex flex-col">
          <div className="w-full mt-2 text-black dark:text-white">
            <span className="font-extrabold text-xl mr-2">Obra: </span>
            {selectedObra.empreendimento && selectedObra.centroCusto && (
              <>
                <span className="mx-1 font-bold text-base">{selectedObra.empreendimento}</span>
                <span className="mx-1 font-bold text-base"> | </span>
                <span className="mx-1 font-normal text-base">{selectedObra.centroCusto}</span>
              </>
            )}
            {selectedObra.empreendimento && !selectedObra.centroCusto && (
              <>
                <span className="mx-1 font-bold text-base">{selectedObra.empreendimento}</span>
              </>
            )}
            {!selectedObra.empreendimento && selectedObra.centroCusto && (
              <>
                <span className="mx-1 font-normal text-base">{selectedObra.centroCusto}</span>
              </>
            )}
          </div>
          {additionalHeader}
        </div>
      )
    );
  }, [
    selectedObra,
    additionalHeader,
  ]);

  return (
    <>
      <div className="w-full flex flex-col justify-between items-center">
        <div className="w-full flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">{title}</h1>
            <RefreshButton onClick={onReload} />
          </div>
        </div>
        {selectedObra && headerObraInformation}
      </div>
      {onNewItem != null && onNewItem !== undefined ? (
        <div className="w-full justify-end items-center flex gap-2">
          <div className="w-[130px] ">
            <PrimaryButton startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />} onClick={onNewItem}>
              Novo item
            </PrimaryButton>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
